import React from "react";
import { removerComponenteReact } from "../renderizarOuRemoverComponentReact";
import { AtendimentoContainer } from "./AtendimentoContainer";

declare const window: any;

export const AtendimentoForaOrcamento = () => {
    const onRemover = () => removerComponenteReact("pesquisar-atendimentos-clientes-region")
    const regiaoRenderizada = "pesquisar-atendimentos-clientes-region"

    return (

        <>
            <AtendimentoContainer
                foraOrcamento={true}
                regiaoRenderizada={regiaoRenderizada}
                onRemover={onRemover}
            />
        </>
    )
}


window.AtendimentoForaOrcamento = AtendimentoForaOrcamento